import React, { Component } from 'react';
import SearchBox from './Components/SearchBox';
export default function Landing() {
 return (<SearchBox />)
}